import * as React from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";

import PageTitle from "@/react/components/PageTitle";
import LabeledSelect from "@/react/components/LabeledSelect";
import PageLayout from "@/react/features/styled/PageLayout";
import ContentWrapper from "@/react/features/styled/PageContentContainer";
import { optionByValue } from "@/react/components/selector-adaptors";

import JobDetailsModal from "./JobDetailsModal";
import JobInventoryTable from "./JobInventoryTable";
import useJobDetails from "./useJobDetails";
import useJobs from "./useJobs";
import { RECENCY_OPTIONS, REFRESH_OPTIONS } from "./constants";

const Controls = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
`;

const Control = styled.div`
  display: flex;
  flex: 1;
  max-width: 400px;
  min-width: fit-content;
`;

const JobInventoryPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { selectedJobDetails, isFetchingJobDetails } = useJobDetails({
    jobId,
    setIsModalOpen,
  });
  const {
    recency,
    setRecency,
    refreshRate,
    setRefreshRate,
    data,
    isFetching,
    refetch,
  } = useJobs();
  const onJobSelected = React.useCallback(
    (jobId) => {
      navigate(`./${jobId}`, { replace: true });
    },
    [navigate]
  );

  return (
    <PageLayout>
      <JobDetailsModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isFetchingJobDetails={isFetchingJobDetails}
        data={selectedJobDetails}
      />
      <ContentWrapper>
        <PageTitle>My Jobs</PageTitle>
        <Controls>
          <Control>
            <LabeledSelect
              populateOnMount
              prompt={"Show From Last..."}
              onSelectionChanged={setRecency}
              options={RECENCY_OPTIONS}
              value={optionByValue(RECENCY_OPTIONS, recency)}
            />
          </Control>
          <Control>
            <LabeledSelect
              populateOnMount
              prompt={"Refresh Every..."}
              onSelectionChanged={setRefreshRate}
              options={REFRESH_OPTIONS}
              value={optionByValue(REFRESH_OPTIONS, refreshRate)}
            />
          </Control>
        </Controls>
        <JobInventoryTable
          refetch={refetch}
          data={data}
          isFetching={isFetching}
          onJobSelected={onJobSelected}
          onSave={() => null}
        />
      </ContentWrapper>
    </PageLayout>
  );
};

export default JobInventoryPage;
